import { API_ROUTES } from '../../config/apiRoutes';
import { toast } from 'react-toastify';

export const PPIMAPI = (token) => ({
  getOverviewStats: async (snapshot) => {
    try {
      const res = await fetch(`${API_ROUTES.OVERVIEW}?stats_date=${snapshot}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      });
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const overview = await res.json();
      toast.success('Overview data loaded successfully.');
      return overview;
    } catch (err) {
      toast.error('Failed to load overview data.');
      throw err;
    }
  },

  getPartnerData: async (stats_date) => {
    try {
      const res = await fetch(`${API_ROUTES.PARTNERS}?stats_date=${stats_date}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      });
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const partners = await res.json();
      toast.success('Partner data loaded successfully.');
      return partners;
    } catch (err) {
      toast.error('Failed to load partner data.');
      throw err;
    }
  },

  getDCUs: async (stats_date, partner, filters, page = 1, pageSize = 1000) => {
    try {
      const params = {
        country: filters.dcuCountry,
        partner,
        connectionStatus: filters.connectionStatus,
        dcus: filters.dcus,
        connectionChanges: filters.connectionChanges,
        ppus: filters.ppus,
        policies: filters.policies,
        stats_date,
        page,
        page_size: pageSize,
      };
      const queryString = new URLSearchParams(params).toString();
      const res = await fetch(`${API_ROUTES.DCUS}?${queryString}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      });
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const dcus = await res.json();
      toast.success('DCU data loaded successfully.');
      return dcus; // { data, total, page, page_size, total_pages }
    } catch (err) {
      toast.error('Failed to load DCU data.');
      throw err;
    }
  },

  getCountries: async (stats_date, partner, filters) => {
    try {
      const res = await fetch(
        `${API_ROUTES.COUNTRIES}?stats_date=${stats_date}&partner=${partner}&country=${filters.country}`,
        {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          }
        }
      );
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const countries = await res.json();
      toast.success('Countries data loaded successfully.');
      return countries;
    } catch (err) {
      toast.error('Failed to load countries data.');
      throw err;
    }
  },

  getPolicies: async (stats_date, partner, pFilters, page = 1, pageSize = 1000) => {
    try {
      const params = new URLSearchParams({
        partner,
        policies: pFilters.policies ?? 'all',
        stats_date,
        page,
        page_size: pageSize,
      });
      if (pFilters.decision?.length) params.append('decision', pFilters.decision.join(','));
      if (pFilters.status?.length) params.append('status', pFilters.status.join(','));
      if (pFilters.monthAssessed && pFilters.monthAssessed !== 'all') {
        params.append('assessment_month', pFilters.monthAssessed);
      }
      const res = await fetch(`${API_ROUTES.POLICIES}?${params}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      });
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const data = await res.json();
      toast.success('Policies data loaded successfully.');
      return data; // { data, total, page, page_size, total_pages }
    } catch (err) {
      toast.error('Failed to load policies data.');
      throw err;
    }
  },

  
  getPolicyById: async (checksum) => {
    try {
      const res = await fetch(`${API_ROUTES.POLICY_SUMMARY}/${checksum}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
      });
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      return await res.json();
    } catch (err) {
      toast.error('Failed to load policy details.');
      throw err;
    }
  },


  updatePolicyStatus: (policyId, { status, reasons, comment }) => {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        try {
          toast.success('Policy status updated successfully.');
          resolve({ success: true });
        } catch (err) {
          toast.error('Failed to update policy status.');
          reject(err);
        }
      }, 500);
    });
  },
});
